<mat-card>
  <mat-card-title>{{ '+USER_DETAILS.PERSONAL_DETAILS.LANGUAGE' | translate }}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div class="flex flex-row gap-[24px]">
        <mat-form-field
          mat-select-height-large
          class="flex-[25%] max-w-[25%] lt-sm:flex-[45%] lt-sm:max-w-[45%]"
          id="language"
          [matTooltip]="
            isOmaUser ? ('+USER_DETAILS.PERSONAL_DETAILS.OMA_EDIT_DISABLED' | translate) : null
          "
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.LANGUAGE' | translate }}</mat-label>
          <mat-select
            [formControl]="formGroup.controls.language"
            data-at-language-edit
            fieldTextContentTooltip
            [disabled]="isOmaUser"
          >
            <mat-option
              *ngFor="let language of languages"
              [value]="language.code"
              gtm="onSelect"
              gtmAction="Language"
              gtmCategory="userLanguageDetails"
              fieldTextContentTooltip
            >
              {{ language.name | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="flex flex-row lt-sm:flex-wrap gap-[24px] lt-sm:gap-[0px]"
        *ngIf="isOmaUser && supportedCountries.length > 0"
      >
        <mat-form-field
          mat-select-height-large
          class="flex-[100%] max-w-[50%] lt-sm:max-w-[100%]"
          id="country"
        >
          <mat-label>{{
            '+USER_DETAILS.PERSONAL_DETAILS.WORK_COUNTRY_CODE' | translate
          }}</mat-label>
          <mat-select
            formControlName="workCountryCode"
            data-at-workCountryCode-edit
            fieldTextContentTooltip
          >
            <mat-option
              *ngFor="let country of supportedCountries"
              [value]="country"
              gtm="onSelect"
              gtmAction="Country"
              gtmCategory="userAddressDetails"
              fieldTextContentTooltip
            >
              {{ country }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center" align="end">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userLanguageDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onSave"
      gtmCategory="userLanguageDetails"
      (click)="dispatchSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
